import {
  addOptionalNullableToSchema,
  addOptionalToSchema,
  emailSchema,
  phoneSchema,
  requiredErrorMessage,
  textSchema,
} from '@common/schema';
import * as yup from 'yup';

export const editContactInformationSchema = yup.object().shape({
  type: yup
    .string()
    .oneOf(['Patient', 'Caregiver', 'Wellness coordinator'])
    .required(requiredErrorMessage),
  do_not_call: yup
    .boolean()
    .when('type', ([type], schema) =>
      type !== 'Wellness coordinator'
        ? schema.required(requiredErrorMessage)
        : yup.boolean().optional().nullable(),
    ),
  language: textSchema.when('type', ([type], schema) =>
    type !== 'Wellness coordinator'
      ? schema.required(requiredErrorMessage)
      : addOptionalToSchema(schema),
  ),
  phone_number: phoneSchema.when('type', ([type], schema) =>
    type !== 'Wellness coordinator'
      ? schema.required(requiredErrorMessage)
      : addOptionalToSchema(schema),
  ),
  email: addOptionalNullableToSchema(emailSchema),
  mobile_phone_number: addOptionalNullableToSchema(phoneSchema),
});
